import React from "react";
import { useTheme } from "@/components/ThemeProvider";

const Logo: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { theme } = useTheme();

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={theme === "dark" ? "/logo-dark.png" : "/logo-light.png"}
        alt="Logo"
        className="w-auto h-10"
      />
    </div>
  );
};

export default Logo;
